import React, { Fragment } from 'react'
import styles from '@/styles/Checkbox.module.scss'

type CheckBoxProps = {
  htmlfor: string
  register: any
  formValueSplit?: any
  required?: any
}

const CheckBox = ({ htmlfor, register, formValueSplit, required }: CheckBoxProps) => {
  return (
    <>
      {formValueSplit.map((check: string, i) => {
        return (
          <Fragment key={i}>
            <label className={`mt-3 flex cursor-pointer items-center`}>
              <input
                className={`${styles.c_checkbox_input}`}
                id={htmlfor}
                name={htmlfor}
                type="checkbox"
                value={`${check}`}
                {...register(htmlfor, {
                  required,
                })}
              />
              <span className={`${styles.c_checkbox_dummyInput}`}></span>
              <span className="ml-2 text-sm">{check}</span>
            </label>
          </Fragment>
        )
      })}
    </>
  )
}

export default CheckBox
